import ScreenRecordIcon from '@atlaskit/icon-lab/core/screen-record';
import * as React from 'react';

export function SvgScreenCam() {
  return <ScreenRecordIcon label="" testId="ads-refreshed-icon" />;
}
